// extracted by mini-css-extract-plugin
export default {"container":"ErrorFallback_container__BHBq1","subContainer":"ErrorFallback_subContainer__abzZp","alert":"ErrorFallback_alert__XZEcz"};